/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Kn_Lv_ExtractInputs */

const cs_enum_kn_lv_extract = /** @type {(inputs: Enum_Kn_Lv_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výpis LV`)
};

const en_enum_kn_lv_extract = /** @type {(inputs: Enum_Kn_Lv_ExtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title-deed extract`)
};

/**
* | output |
* | --- |
* | "Title-deed extract" |
*
* @param {Enum_Kn_Lv_ExtractInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_kn_lv_extract = /** @type {((inputs?: Enum_Kn_Lv_ExtractInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Kn_Lv_ExtractInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_kn_lv_extract(inputs)
	return cs_enum_kn_lv_extract(inputs)
});